"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setCategory_1 = require("../mutators/setCategory");
var setSubCategoryState_1 = require("../mutators/setSubCategoryState");
var getCurrentSubcategory_1 = require("../selectors/getCurrentSubcategory");
var store_1 = require("../store/store");
function updateCategory(categoryKey, subcategoryKey, currentOptionKey) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        function areCategoryAndSubCategoryUnchanged() {
            var store = store_1.getStore();
            return (store.currentCategoryKey === categoryKey &&
                store.currentSubCategoryKey === subcategoryKey);
        }
        var subCategory, success, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCategory_1.default(categoryKey, subcategoryKey, currentOptionKey);
                    subCategory = getCurrentSubcategory_1.default();
                    if (!subCategory.onSelected) return [3 /*break*/, 5];
                    setSubCategoryState_1.default(0 /* Loading */);
                    success = void 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, subCategory.onSelected()];
                case 2:
                    success = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    success = false;
                    return [3 /*break*/, 4];
                case 4:
                    if (areCategoryAndSubCategoryUnchanged()) {
                        setSubCategoryState_1.default(success ? 1 /* Loaded */ : 2 /* Error */);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setSubCategoryState_1.default(1 /* Loaded */);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.default = updateCategory;
//# sourceMappingURL=updateCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/orchestrators/updateCategory.js
// module id = 3414
// module chunks = 2